import React, {useEffect, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {useSelector} from "react-redux";
import Cookies from 'js-cookie';
import axios from 'axios';

import {API_CORE_URL, jobCategories, STORAGE_URL} from 'constants/index.js';

import InputCustom from 'views/pages/components/InputCustom';
import InputFile from 'views/pages/components/InputFile';
import {InputArraySelect, InputKeySelect,} from 'views/pages/components/InputSelect';
import TableCustom from 'views/pages/components/TableCustom';

import {Badge, Card, CardBody, CardHeader, Col, Container, Modal, Row} from "reactstrap";

import {create, deletee, manageUsers,} from 'views/policies/UserPolicy';

import CardsHeader from 'layouts/Headers/CardsHeader.js';
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import notify from "@utils/notify";
import UserForm from "@pages/components/user/UserForm";

export default function User() {
  const history = useHistory();

  const profileData = useSelector((state) => state.getState).profileData;
  const permissions = useSelector((state) => state.getState).permissions;

  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);
  const [isNotValid, setIsNotValid] = useState(true);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);

  const [confirmShow, setConfirmShow] = useState(false);
  const [selectedId, setSelectedId] = useState('');

  const [addModal, setAddModal] = useState(false);

  const fetchData = async () => {
    try {
      const userResponse = await axios({
        method: 'GET',
        url: API_CORE_URL + '/user',
      })
      if (userResponse.status === 200) {
        const data = userResponse.data.data;
        setUsers(data);
      }
      const roleResponse = await axios({
        method: 'GET',
        url: API_CORE_URL + '/role',
      })
      if (roleResponse.status === 200) {
        const data = roleResponse.data.data;
        setRoles(data);
      }
      setTimeout(() => {
        setLoading(false)
      }, 500);
    } catch (e) {
      console.error('error :: ', e);
      notify.warning(e);
    }

  }
  useEffect( () => {
     fetchData()
  }, [])


  const submitData = ({data}) => {
    setUsers([...users,...[data]]);
    setAddModal(false)
    notify.success('User created successfully');
  }
  const resetData = () => {
    setAddModal(false)
  }
  const editUser = (row) => {
    history.push({
      pathname: profileData.id === row.id? '/admin/profile': '/admin/user/' + row.id + '/edit'
    });
  }

  const deleteUser = () => {
    axios({
      method: 'DELETE',
      url: API_CORE_URL + '/user/' + selectedId,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(() => {
          setConfirmShow(false);
          let tempItems = users.filter(user=>user.id !== selectedId)
          setUsers(tempItems)
          notify.success('Success');
      })
      .catch(error => {
        setConfirmShow(false);
        console.error('error :: ', error);
        notify.error(error.response.statusText);
      })
  }

  const editHoliday = (user) => {
    history.push({
      pathname: `/admin/holiday/${user.id}/user`,
      state: {
        user_name: user.name
      }
    })
  }

  return (
    <>
      <CardsHeader name="Admin" parentName="User Management" currentName="List" />
      <Container className="mt--6 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col xs={8}>
                    <h1 className="mb-0">Users</h1>
                    <p className="text-sm mb-0">Users management section.</p>
                  </Col>
                  <Col xs={4} className="text-right">
                    {create(permissions) &&
                    <ButtonContainer onClick={() => setAddModal(true)}>
                      <i className="fa fa-plus" aria-hidden="true"></i>
                      Add user
                    </ButtonContainer>}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <TableCustom
                  loading={loading}
                  keyField={`name`}
                  searchField={true}
                  items={users}
                  columns={[
                    {
                      dataField: "photo",
                      text: "Photo",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return (
                          <span className="avatar avatar-sm rounded-circle">
                            {row.picture ? (<img
                              alt={row.name ? row.name.slice(0, 2) : ''}
                              src={STORAGE_URL + row.picture}
                            />)
                              : (row.name ? row.name.slice(0, 2) : '')}
                          </span>
                        )
                      }
                    },
                    {
                      dataField: "name",
                      text: "Name",
                      sort: true
                    },
                    {
                      dataField: "email",
                      text: "Email",
                      sort: true
                    },
                    {
                      dataField: "is_active",
                      text: "Is active(Login)",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return (
                          <Badge color={row.is_active === 1? 'success': 'light'}>{row.is_active === 1? `Yes`: 'No'}</Badge>
                        );
                      }
                    },
                    {
                      dataField: "role",
                      text: "Roles",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return(
                          <span>
                            {row.roles && row.roles.length > 0 && row.roles.map((item) => {
                              return item.name;
                            })}
                          </span>
                        )
                      }
                    },
                    {
                      dataField: "created_at",
                      text: "Creation date",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return row.created_at;
                      }
                    },
                    {
                      dataField: "action",
                      text: "Action",
                      formatter: (rowContent, row) => {
                        return (
                          <>
                            {manageUsers(permissions) &&
                              <>
                                <IcoMoon
                                    className={'cursor-pointer'}
                                    iconSet={IconSet}
                                    icon={'edit'}
                                    size={24}
                                    onClick={() => editUser(row)}
                                />
                                <IcoMoon
                                    className={'cursor-pointer'}
                                    iconSet={IconSet}
                                    icon={'visibility'}
                                    size={24}
                                    onClick={() => editHoliday(row)}
                                />
                                {deletee(permissions, profileData, row) &&
                                <IcoMoon
                                    className={'cursor-pointer'}
                                    iconSet={IconSet}
                                    icon={'delete_outline'}
                                    size={24}
                                    onClick={() => {
                                      setConfirmShow(true);
                                      setSelectedId(row.id);
                                    }}
                                />
                                }
                              </>
                             }
                          </>
                        )
                      }
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <UserForm submitData={submitData} addModal={addModal} setAddModal={setAddModal} defaultValues={{}} jobCategories={jobCategories} resetData={resetData} roles={roles}/>
        <Modal
          isOpen={confirmShow}
          toggle={() => setConfirmShow(false)}
          className="modal-dialog-centered modal-secondary"
        >
          <div className="modal-body text-center">
            {`Are you sure you want to delete this user?`}
          </div>
          <div className="modal-footer justify-content-center">
            <ButtonContainer
                onClick={() => setConfirmShow(false)}
            >
              Cancel
            </ButtonContainer>
            <ButtonContainer
              reverse
              onClick={() => deleteUser()}
            >
              {`Delete`}
            </ButtonContainer>

          </div>
        </Modal>
      </Container>
    </>
  )
}